import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch } from 'react-icons/fa';
import instanciaAxios from '../../../miscelaneo/instanciaAxios';
import SpinnerCargando from '../SpinnerCargando';
import FuncionesGenerales from '../FuncionesGenerales';

/**
 * Tabla para listar pagos al exterior (E47)
 * Basado en TablaEgreso.js
 */
function TablaPagoExterior({ handleSeleccionar = () => {} }) {
  const [filtro, setFiltro] = useState('');
  const [pagos, setPagos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const { formatearFechaInput, formatoMoneda } = FuncionesGenerales();

  const handleRowClick = (pago) => {
    handleSeleccionar(pago);
  };

  useEffect(() => {
    (async () => {
      try {
        setCargando(true);
        const res = await instanciaAxios.get('/pago-exterior');
        setPagos(res.status === 200 ? res.data : []);
      } catch {
        setPagos([]);
      } finally {
        setCargando(false);
      }
    })();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return pagos;
    const filtroLower = filtro.toLowerCase();
    return pagos.filter((pago) =>
      pago?.id_pago_exterior?.toString().includes(filtroLower) ||
      (pago?.ncf || '').toLowerCase().includes(filtroLower) ||
      (pago?.identificador_extranjero || '').toLowerCase().includes(filtroLower) ||
      (pago?.razon_social_beneficiario || '').toLowerCase().includes(filtroLower) ||
      (pago?.pais_destino || '').toLowerCase().includes(filtroLower) ||
      (pago?.concepto || '').toLowerCase().includes(filtroLower) ||
      (pago?.monto_total?.toString() || '').includes(filtroLower)
    );
  }, [filtro, pagos]);

  const columns = [
    {
      name: 'ID',
      selector: row => row.id_pago_exterior,
      sortable: true,
      width: '70px'
    },
    {
      name: 'NCF',
      selector: row => row.ncf || '-',
      sortable: true,
      width: '140px'
    },
    {
      name: 'Beneficiario',
      selector: row => row.razon_social_beneficiario,
      sortable: true,
      wrap: true
    },
    {
      name: 'ID Extranjero',
      selector: row => row.identificador_extranjero,
      sortable: true,
      width: '120px'
    },
    {
      name: 'País',
      selector: row => row.pais_destino || '-',
      sortable: true,
      width: '110px'
    },
    {
      name: 'Monto Total',
      selector: row => formatoMoneda(row.monto_total),
      sortable: true,
      width: '120px',
      right: true
    },
    {
      name: 'ISR Retenido',
      selector: row => formatoMoneda(row.isr_retenido_total),
      sortable: true,
      width: '110px',
      right: true,
      cell: row => (
        <span className="text-blue-600 font-medium">
          {formatoMoneda(row.isr_retenido_total)}
        </span>
      )
    },
    {
      name: 'Fecha',
      selector: row => formatearFechaInput(row.fecha_hora),
      sortable: true,
      width: '100px'
    },
    {
      name: 'DGII',
      selector: row => row.tiene_e47 ? (
        <span className="text-green-600 font-medium text-xs">✓ Enviado</span>
      ) : (
        <span className="text-yellow-600 font-medium text-xs">⏳ Pendiente</span>
      ),
      sortable: true,
      width: '90px'
    }
  ];

  if (cargando) return <SpinnerCargando />;

  if (pagos.length === 0) {
    return (
      <div className="text-gray-500 text-center py-8">
        No se encontraron pagos al exterior.
      </div>
    );
  }

  return (
    <DataTable
      keyField="id_pago_exterior"
      title={
        <h2 className="text-xl font-semibold text-center flex items-center justify-center gap-2">
          <span>🌎</span> Pagos al Exterior (E47)
        </h2>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 50]}
      dense
      highlightOnHover
      pointerOnHover
      onRowClicked={handleRowClick}
      noDataComponent={
        <div className="text-gray-500 py-4">No se encontraron pagos al exterior.</div>
      }
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar pago al exterior..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
}

export default TablaPagoExterior;







